import authService from '../../services/auth';
import companyService from '../../services/company';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'shopifyAuth',
  components: { VueRecaptcha },
  data() {
    return {
      isLoading: true,
      setupInProgress: true,

      storeId: '',
      ownerEmail: '',
      accessToken: ''
    };
  },
  computed: {},
  methods: {
    // validate the token
    async verifyShopifyIntegration() {
      try {
        let params = {
          storeId: this.storeId,
          ownerEmail: this.ownerEmail,
          accessToken: this.accessToken
        };

        // validate the shopify token
        let result = await authService.validateShopifyToken(params);
        // 'no-company' | 'login' | 'in-progress'
        if (result.data.status === 'no-company') {
          // Create a new company api, show create company loader.
          // TODO: Hit Create Company API.
          this.isLoading = false;
          this.setupInProgress = true;
          await this.createCompany();
          // Wait for 5 seconds to create the company.
          await new Promise((resolve) => setTimeout(resolve, 5000));
          await this.verifyShopifyIntegration();
        } else if (result.data.status === 'in-progress') {
          // Loop - Check for company creation is done.
          this.isLoading = false;
          this.setupInProgress = true;
          this.loadingMsg = 'Setting up your account, this may take one or two minutes. Please do not refresh the browser.';

          // Wait for 5 seconds to check the company creation status.
          await new Promise((resolve) => setTimeout(resolve, 5000));
          await this.verifyShopifyIntegration();
        } else if (result.data.status === 'login') {
          // Else - Do User Login.

          this.isLoading = true;
          this.setupInProgress = false;
          this.successToast('Login successful.');

          // Do User Login.
          this.handleNewSession(result.data.login);

          // Do Company Login.
          let sessionResult = await companyService.createSessionForThatCompany(result.data.companyId);
          this.handleNewSession(sessionResult.data, false, '/shopify-welcome');
        } else {
          throw new Error('Invalid status from server.');
        }
      } catch (err) {
        this.errorToast('Something went wrong. Please contact support team.');
      }
    },

    // register
    async createCompany() {
      try {
        let params = {
          accessToken: this.accessToken,
          storeId: this.storeId,
          ownerEmail: this.ownerEmail
        };

        // Create Company.
        console.log('Start: Create Company:', params);
        await authService.registerThroughShopify(params);
        console.log('Finished: Created Company');

        let instance = this;
        setTimeout(async () => {
          console.log('Start: Shopify verification check loop');
          instance.verifyShopifyIntegration();
        }, 1500);
      } catch (error) {
        //Something is wrong, please contact support.
        // this.reportError(error);
        this.onCaptchaExpired();
        this.errorToast(`Something's not right. Please contact support team.`);
        this.registerProcessing = false;
      }
    }
  },

  mounted() {
    let token = this.$route.query.token;
    if (!token) {
      this.errorToast('Invalid Request.');
      return;
    }

    try {
      // Convert token into json object.
      let tokenStr = Buffer.from(token, 'base64').toString('binary');
      let info = JSON.parse(tokenStr);
      console.log('Token info', info);

      // Store the token for later use.
      this.storeId = info.store;
      this.ownerEmail = info.email;
      this.accessToken = info.access_token;

      this.verifyShopifyIntegration();
    } catch (error) {
      this.errorToast('Invalid Request.');
      return;
    }
  }
};
